import Cookies from 'js-cookie';

const markInfoBarAsRead = () => {
  Cookies.set('_isInfoRead', 'true', { expires: 1 });
};

export const infoBarEvents = [
  ['jsInfoBarDismissed', markInfoBarAsRead, 'closed.bs.alert'],
];
